export const inputJaName = ({ name, isAdmin }) => {
  return isAdmin ? `creator_audition[ja][${name}]` : `creator_audition[${name}]`
}

export const inputEnName = ({ name }) => {
  return `creator_audition[en][${name}]`
}
